import type { RequestPart } from '@nest-recruit/shared';

/**
 * ADR 0075 (B2): the request's parts that land in the job's Basics, so the "Edited by HR" marks carried from the request show
 * there. The brief's parts show on the Brief, the ideal candidate in its own section.
 */
export const REQUEST_BASICS_PARTS: readonly RequestPart[] = [
  'title',
  'slotsRequested',
  'lineManager',
  'hiringManager',
  'workMode',
  'location',
  'budget',
  'publicTitle',
  'employmentType',
  'roleFamily',
  'start',
  'targetCloseDate',
  'isConfidential',
  'managesPeople',
  'shift',
  'description',
  'responsibilities',
  'requirements',
];
